"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkdownNode = exports.renderMarkdown = void 0;
const showdown = __importStar(require("showdown"));
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const lodash_1 = __importDefault(require("lodash"));
const types_1 = require("./types");
const ALLOWED_MARKDOWN_TAGS = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'a',
    'em',
    'b',
    'ol',
    'ul',
    'li',
    'strong',
    'br',
];
const VARIABLE_REGEX = /{{(\w+(.\w+)*)}}/g;
const underlinedPlaceholder = (fieldName) => {
    const name = fieldName
        .split('.')
        .map((val) => val.split(/(?=[A-Z])/).join(' '))
        .map((val) => val.charAt(0).toUpperCase() + val.substring(1))
        .join(' ');
    return `
    <div class="placeholder-container">
      <div class="underline"></div>
      <div class="helper-text">${name}</div>
    </div>
  `;
};
// Replaces each variable in the Markdown with the default preview values, as well as wraps it in
// a span with a specific class so we can make it look different with CSS (be it with pills,
// different color, whatever)
// EX: {{contractor.firstName}} becomes
// <span class="variable contractor firstName">Contractor First Name</span>
const wrapVariablesForPreview = (html, args) => {
    // Obviously move this out of here into its own file/type since many nodes are going to use
    // variables and variable previews.
    return html.replace(VARIABLE_REGEX, (m, p1) => {
        const val = replaceVariableToken(m, p1, args, true);
        if (val === m) {
            return underlinedPlaceholder(p1);
        }
        return val;
    });
};
// Takes a Regex-searched variable token, with two capture groups {{p1.p2}}, and replaces it with
// the RenderArgs if the variable token is a valid match, otherwise just returns the `{{}}`.
const replaceVariableToken = (match, p1, args, preview) => {
    const value = lodash_1.default.get(args, p1);
    if (!value && preview) {
        return match;
    }
    if (!value) {
        throw new Error(`Variable ${p1} not found.`);
    }
    return sanitize_html_1.default(value, { allowedTags: [], allowedAttributes: {} });
};
// Probably a million better ways to do this, I am doing this to learn a bit and am allowing myself
// to be reprimanded.
const replaceVariablesWithValues = (html, args) => {
    // Obviously move this out of here into its own file/type since many nodes are going to use
    // variables and variable previews.
    return html.replace(VARIABLE_REGEX, (m, p1) => (replaceVariableToken(m, p1, args, false)));
};
const renderMarkdown = (markdown) => {
    const converter = new showdown.Converter({ simpleLineBreaks: true });
    converter.setOption('noHeaderId', true);
    return sanitize_html_1.default(converter.makeHtml(markdown), {
        allowedTags: ALLOWED_MARKDOWN_TAGS,
        allowedAttributes: { a: ['href', 'name', 'target'], },
    });
};
exports.renderMarkdown = renderMarkdown;
const MarkdownNode = (config) => ({
    id: config.id,
    version: 1,
    type: types_1.NodeTypes.MarkdownNode,
    render: (args) => {
        return replaceVariablesWithValues(exports.renderMarkdown(config.attributes.body), args);
    },
    preview: (args) => {
        return wrapVariablesForPreview(exports.renderMarkdown(config.attributes.body), args);
    }
});
exports.MarkdownNode = MarkdownNode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2Rvd25Ob2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9ub2Rlcy9tYXJrZG93bk5vZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLG1EQUFxQztBQUNyQyxrRUFBeUM7QUFDekMsb0RBQXVCO0FBRXZCLG1DQUF5RDtBQUd6RCxNQUFNLHFCQUFxQixHQUFHO0lBQzVCLEdBQUc7SUFDSCxJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixHQUFHO0lBQ0gsSUFBSTtJQUNKLEdBQUc7SUFDSCxJQUFJO0lBQ0osSUFBSTtJQUNKLElBQUk7SUFDSixRQUFRO0lBQ1IsSUFBSTtDQUNMLENBQUM7QUFFRixNQUFNLGNBQWMsR0FBRyxtQkFBbUIsQ0FBQztBQUUzQyxNQUFNLHFCQUFxQixHQUFHLENBQUMsU0FBaUIsRUFBVSxFQUFFO0lBQzFELE1BQU0sSUFBSSxHQUFHLFNBQVM7U0FDbkIsS0FBSyxDQUFDLEdBQUcsQ0FBQztTQUNWLEdBQUcsQ0FBQyxDQUFDLEdBQVcsRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7U0FDdEQsR0FBRyxDQUFDLENBQUMsR0FBVyxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRSxHQUFHLEdBQUcsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDcEUsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ2IsT0FBTzs7O2lDQUd3QixJQUFJOztHQUVsQyxDQUFDO0FBQ0osQ0FBQyxDQUFBO0FBRUQsaUdBQWlHO0FBQ2pHLDRGQUE0RjtBQUM1Riw2QkFBNkI7QUFDN0IsdUNBQXVDO0FBQ3ZDLDJFQUEyRTtBQUMzRSxNQUFNLHVCQUF1QixHQUFHLENBQUMsSUFBWSxFQUFFLElBQVMsRUFBVSxFQUFFO0lBQ2xFLDJGQUEyRjtJQUMzRixtQ0FBbUM7SUFDbkMsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLGNBQWMsRUFBRSxDQUFDLENBQUMsRUFBRSxFQUFFLEVBQUUsRUFBRTtRQUM1QyxNQUFNLEdBQUcsR0FBRyxvQkFBb0IsQ0FBQyxDQUFDLEVBQUUsRUFBRSxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztRQUNwRCxJQUFJLEdBQUcsS0FBSyxDQUFDLEVBQUU7WUFDYixPQUFPLHFCQUFxQixDQUFDLEVBQUUsQ0FBQyxDQUFDO1NBQ2xDO1FBQ0QsT0FBTyxHQUFHLENBQUM7SUFDYixDQUFDLENBQUMsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLGlHQUFpRztBQUNqRyw0RkFBNEY7QUFDNUYsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLEtBQWEsRUFBRSxFQUFVLEVBQUUsSUFBZ0IsRUFBRSxPQUFnQixFQUFVLEVBQUU7SUFDckcsTUFBTSxLQUFLLEdBQUcsZ0JBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzlCLElBQUksQ0FBQyxLQUFLLElBQUksT0FBTyxFQUFFO1FBQ3JCLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7SUFDRCxJQUFJLENBQUMsS0FBSyxFQUFFO1FBQ1YsTUFBTSxJQUFJLEtBQUssQ0FBRSxZQUFZLEVBQUUsYUFBYSxDQUFDLENBQUM7S0FDL0M7SUFDRCxPQUFPLHVCQUFZLENBQUMsS0FBSyxFQUFFLEVBQUUsV0FBVyxFQUFFLEVBQUUsRUFBRSxpQkFBaUIsRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0FBQ3pFLENBQUMsQ0FBQztBQUVGLG1HQUFtRztBQUNuRyxxQkFBcUI7QUFDckIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQVksRUFBRSxJQUFnQixFQUFVLEVBQUU7SUFDNUUsMkZBQTJGO0lBQzNGLG1DQUFtQztJQUNuQyxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsY0FBYyxFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FDN0Msb0JBQW9CLENBQUMsQ0FBQyxFQUFFLEVBQUUsRUFBRSxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQ3pDLENBQUMsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVLLE1BQU0sY0FBYyxHQUFHLENBQUMsUUFBZ0IsRUFBVSxFQUFFO0lBQ3pELE1BQU0sU0FBUyxHQUFHLElBQUksUUFBUSxDQUFDLFNBQVMsQ0FBQyxFQUFFLGdCQUFnQixFQUFFLElBQUksRUFBRSxDQUFDLENBQUM7SUFDckUsU0FBUyxDQUFDLFNBQVMsQ0FBQyxZQUFZLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFDeEMsT0FBTyx1QkFBWSxDQUNqQixTQUFTLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxFQUM1QjtRQUNFLFdBQVcsRUFBRSxxQkFBcUI7UUFDbEMsaUJBQWlCLEVBQUUsRUFBRSxDQUFDLEVBQUUsQ0FBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLFFBQVEsQ0FBRSxHQUFHO0tBQ3hELENBQ0YsQ0FBQztBQUNKLENBQUMsQ0FBQztBQVZXLFFBQUEsY0FBYyxrQkFVekI7QUFFSyxNQUFNLFlBQVksR0FBRyxDQUFDLE1BQXNCLEVBQW9CLEVBQUUsQ0FBQyxDQUFDO0lBQ3pFLEVBQUUsRUFBRSxNQUFNLENBQUMsRUFBRTtJQUNiLE9BQU8sRUFBRSxDQUFDO0lBQ1YsSUFBSSxFQUFFLGlCQUFTLENBQUMsWUFBWTtJQUM1QixNQUFNLEVBQUUsQ0FBQyxJQUFnQixFQUFFLEVBQUU7UUFDM0IsT0FBTywwQkFBMEIsQ0FBQyxzQkFBYyxDQUFDLE1BQU0sQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFDbEYsQ0FBQztJQUNELE9BQU8sRUFBRSxDQUFDLElBQWdCLEVBQUUsRUFBRTtRQUM1QixPQUFPLHVCQUF1QixDQUFDLHNCQUFjLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUMvRSxDQUFDO0NBQ0YsQ0FBQyxDQUFDO0FBVlUsUUFBQSxZQUFZLGdCQVV0QiJ9